module.exports = __webpack_public_path__ + "img/Andreas.aec161b8.png";